import { ajaxService } from '../../common/Services';
import { ApiUtils } from '../../common/api';

import Model from './display-container-model.js';
import Collection from './display-container-collection.js';

function _updateSerializedDisplayContainer(serializedPayload) {
  const { id, ...rest } = serializedPayload;

  return ajaxService
    .post(
      `/api/xp/container/update/${id}.json`,
      {
        ...rest,
      },
      undefined,
      { postJSON: true }
    )
    .then(ApiUtils.validate, ApiUtils.validate)
    .then(ApiUtils.extract1)
    .then((data) => Model.deserialize(data))
    .catch((error) => ({ error: ApiUtils.buildErrorObject(error) }));
}

function updateDisplayContainer(displayContainer, isMacroExperience) {
  return _updateSerializedDisplayContainer(Model.serialize(displayContainer, isMacroExperience));
}

/**
 * Fetch all containers for a given channel
 * @param {number} channelId
 * @param {object} opts
 * @returns {Collection}
 */

export const fetchContainersWithEmbedCodes = (channelId, opts = {}) => {
  return ajaxService
    .get(
      '/api/xp/container/listWithEmbedCodes.json',
      Object.assign(
        {},
        {
          channelId,
          max: 500,
        },
        opts
      ),
      { cache: false, timeout: 120000 }
    )
    .then(ApiUtils.validate)
    .then(ApiUtils.extract)
    .then(Collection.deserialize)
    .catch((error) => ({ error }));
};

const deleteContainer = (containerId) => {
  return ajaxService
    .post(`/api/xp/container/delete/${containerId}`)
    .then(ApiUtils.validate)
    .catch((error) => ({ error: ApiUtils.buildErrorObject(error) }));
};

const publishContainer = (containerId) => {
  return ajaxService
    .post(`/api/xp/container/publishNow/${containerId}`, { validate: true }, {}, { cache: false })
    .then(ApiUtils.validate)
    .then(ApiUtils.extract1)
    .then((response) => response.displayContainer) // this API sends back the DC, DU, channel etc. so we just want the DC
    .then((data) => Model.deserialize(data))
    .catch((error) => ({ error: ApiUtils.buildErrorObject(error) }));
};

const expireContainer = (containerId) => {
  return ajaxService
    .post(`/api/xp/container/expireNow/${containerId}`, { validate: true }, {}, { cache: false })
    .then(ApiUtils.validate)
    .then(ApiUtils.extract1)
    .then((response) => response.displayContainer) // this API sends back the DC, DU, channel etc. so we just want the DC
    .then((data) => Model.deserialize(data))
    .catch((error) => ({ error: ApiUtils.buildErrorObject(error) }));
};

const setDefault = (containerId) => {
  return ajaxService
    .post(`/api/xp/container/setDefault/${containerId}`)
    .then(ApiUtils.validate)
    .then(ApiUtils.extract1)
    .then((response) => response.displayContainer) // this API sends back the DC, DU, channel etc. so we just want the DC
    .then(Model.deserialize)
    .catch((error) => ({ error: ApiUtils.buildErrorObject(error) }));
};

const setRoot = (containerId) => {
  return ajaxService
    .post(`/api/xp/container/setRoot/${containerId}`)
    .then(ApiUtils.validate)
    .then(ApiUtils.extract1)
    .then((response) => response.displayContainer) // this API sends back the DC, DU, channel etc. so we just want the DC
    .then(Model.deserialize)
    .catch((error) => ({ error: ApiUtils.buildErrorObject(error) }));
};

export const fetchThirdPartyProviderCode = (params) => {
  return ajaxService
    .get('/api/util/privacyManagementConfig.json', params)
    .then(ApiUtils.validate)
    .then(ApiUtils.extract1)
    .catch((error) => ({ error }));
};

export default {
  deleteContainer,
  expireContainer,
  fetchContainersWithEmbedCodes,
  publishContainer,
  setDefault,
  setRoot,
  updateDisplayContainer,
  fetchThirdPartyProviderCode,
};
